import axios from '../../app/api/axios';
import {CONTACT_FORM_ERROR, CONTACT_FORM_SENDING, CONTACT_FORM_SENT} from './types';
import {GET_ERRORS} from '../Errors/types';
import {clearErrors} from "../Errors/actions";

export const sendEmail = (data) => dispatch => {
    dispatch(clearErrors());
    dispatch(setContactFormSending());

    axios.post('agep/v1/contact/form', data)
        .then(res => {
            dispatch({
                type: CONTACT_FORM_SENT,
                payload: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: CONTACT_FORM_ERROR
            });

            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            });
        });
};

export const setContactFormSending = () => {
    return {
        type: CONTACT_FORM_SENDING
    };
};


// WEBPACK FOOTER //
// ./src/features/Contact/actions.js